export default "__VITE_ASSET__BXsAPwhR__"